import type { EventCollectionId } from "../workspace/collectionIds";

export function contentReleaseVersionFromRef(ref: unknown): number | undefined {
  if (ref == null || typeof ref !== "object") {
    return undefined;
  }
  const id =
    "id" in ref && typeof (ref as { id?: unknown }).id === "string"
      ? (ref as { id: string }).id
      : undefined;
  if (!id) {
    return undefined;
  }
  const parsed = Number.parseInt(id, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

/** Catalog lives under `contentReleases/{version}`; null if nothing is published. */
export function eventContentScopeId(
  eventId: EventCollectionId,
  contentReleaseRef: unknown
): EventCollectionId | null {
  const version = contentReleaseVersionFromRef(contentReleaseRef);
  if (version == null) {
    return null;
  }
  return { ...eventId, version };
}
